import { Card, Col, Divider, Row, Typography } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { CisData } from "../PaymentCis";
import { images } from "../../../routes/ImageRoutes";
import { Link } from "react-router-dom";

interface Props {
    cisList: Array<CisData>;
}

const PaymentCistList = (props: Props) => {
    const { cisList } = props;
    const { Text } = Typography;

    return (
        <>
            <Row gutter={[16, 16]}>
                {cisList.map((cis, index) => (
                    <Col xs={24} xl={12} key={index}>
                        <Link
                            to={`https://www.google.com/maps/search/?api=1&query=${cis.latitude},${cis.longitude}`}
                            target='_blank'
                        >
                            <Card style={styles.cardView}

                            >
                                <Row style={styles.rowRoot}>
                                    <Col xs={24} md={3}>
                                        <Text style={styles.cisDistance}>{cis.distance}</Text>
                                    </Col>
                                    <Col xs={24} md={2}>
                                        <Divider type="vertical" style={styles.divider} />
                                    </Col>
                                    <Col xs={24} md={17}>
                                        <div style={styles.dataView}>
                                            <Text style={styles.cisName} >{cis.name}</Text>
                                            <Text style={styles.cisAdress}>{cis.address}</Text>
                                            <Text style={styles.cisAdress}>{cis.suburb}</Text>
                                        </div>
                                    </Col>
                                    <Col xs={24} md={2} style={styles.colView}>
                                        <img style={styles.imageStores} src={images.location} alt="Mega Logo" />
                                    </Col>
                                </Row>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
        </>

    )
}

const styles = StyleSheet.create({
    rowRoot: {
        width: "100%",
        alignItems: 'center'
    },
    cardView: {
        backgroundColor: 'white',
        borderRadius: 15,
        boxShadow: "0px 0px 8px #00000029",
        minHeight: 120
    },
    divider: {
        backgroundColor: '#0055c2',
        height: 45,
        width: 1.5
    },
    dataView: {
        display: 'flex',
        flexDirection: 'column'
    },
    colView: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    cisDistance: {
        color: '#0055c2',
        fontWeight: 600
    },
    cisName: {
        color: '#0055c2',
        fontWeight: 600
    },
    cisAdress: {
        color: '#848589'
    },
    imageStores: {
        height: 30
    },
});

export default PaymentCistList;
